import React, { Children, useEffect, useState, useRef } from "react";
import { updateToolSettings, getToolSettings } from "../API";
import _forOwn from "lodash/forOwn";
import _ from "lodash";
import HelperService from "../Helpers/HelperService";
import {
  sensorLive,
  channelColors,
  toolSyncTime,
  Metrics,
  Colors,
} from "../global";
import { View, Text, Button, Dashboard, Alert, Row, Icon } from "../Components";
// import NavigationService from '../Services/NavigationService'
// import { useFocusEffect } from '@react-navigation/native'
import { ReactComponent as toolIcon } from "../Assets/SVG/ChemSense_Big.svg";
import { Row as ViewRow } from "antd";
// import { getAllGraphData } from '../Stores/Tools/Selectors'
import { ReactComponent as phIcon } from "../Assets/SVG/Ph.svg";
import { ReactComponent as orpIcon } from "../Assets/SVG/ORP.svg";
import { ReactComponent as ambIcon } from "../Assets/SVG/AmbTemp.svg";
import { ReactComponent as thermIcon } from "../Assets/SVG/ChemThermo.svg";
import { ReactComponent as unitIcon } from "../Assets/SVG/Unit_Small.svg";
import { ReactComponent as powerIcon } from "../Assets/SVG/Power_Small.svg";
import { ReactComponent as sensorIcon } from "../Assets/SVG/SensorType.svg";
import { ReactComponent as calibrationIcon } from "../Assets/SVG/Calibration.svg";
import { allSitesAtom } from "../Atoms/allSitesAtom"; //"./Atoms/allSitesAtom";
import { useRecoilState } from "recoil";
import { useAuthenticator } from "@aws-amplify/ui-react";

const styles = {
  dashboardView: {
    flexGrow: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
  },
  dashboardValue: {
    width: "50%",
  },
  overviewValue: {
    width: "100%",
  },
};

const thermoProbeType = ["J", "K", "T", "E", "R", "S", "B", "N"];

const SCP1 = ({ children }) => (
  <View>
    {Children.map(children, (child, i) => {
      return <View key={i}>{child}</View>;
    })}
  </View>
);

export const SCP1_CH_ENUM = ["scp1_chem1", "scp1_tAmb", "scp1_tTC"];

export const SCP1_CHANNEL_ICONS = (tool) => {
  if (
    _.has(tool.settings.channels, "scp1_chem1") &&
    tool.settings.channels.scp1_chem1.sensorType == "pH"
  ) {
    return [phIcon, ambIcon, thermIcon];
  } else {
    return [orpIcon, ambIcon, thermIcon];
  }
};

export const SCP1_DEFAULT_Y_AXIS = (settings) => {
  let defaultAxis = [];
  let tempChannels = [];
  if (settings.channels["scp1_chem1"]) {
    if (settings.channels.scp1_chem1.sensorType == "pH") {
      defaultAxis.push({
        enabled: true,
        name: "pH Axis",
        channels: [0],
        auto: true,
        min: 0,
        max: 100,
      });
    } else {
      defaultAxis.push({
        enabled: true,
        name: "ORP Axis",
        channels: [0],
        auto: true,
        min: 0,
        max: 100,
      });
    }
  }
  if (settings.channels["scp1_tAmb"].enabled) tempChannels.push(1);
  if (settings.channels["scp1_tTC"].enabled) tempChannels.push(2);
  if (!_.isEmpty(tempChannels))
    defaultAxis.push({
      enabled: true,
      name: "Temperature Axis",
      channels: tempChannels,
      auto: true,
      min: 0,
      max: 100,
    });
  return defaultAxis;
};

export const SCP1_ENABLED_CHANNELS = (tool, addTS) => {
  let enabledChannels = [];
  if (addTS) enabledChannels.push("ts");
  if (tool.settings.channels.scp1_chem1.sensorType == "pH") {
    if (tool.settings.channels.scp1_chem1.enabled)
      enabledChannels.push(SCP1_CH_ENUM[0]);
  } else if (tool.settings.channels.scp1_chem1.sensorType == "ORP") {
    if (tool.settings.channels.scp1_chem1.enabled)
      enabledChannels.push(SCP1_CH_ENUM[0]);
  }
  if (tool.settings.channels.scp1_tAmb.enabled)
    enabledChannels.push(SCP1_CH_ENUM[1]);
  if (tool.settings.channels.scp1_tTC.enabled)
    enabledChannels.push(SCP1_CH_ENUM[2]);
  return enabledChannels;
};

export const SCP1_CHANNEL_ARRAY = (tool, channels) => {
  let channelArray = [];
  let channelContent;
  try {
    //pH or ORP
    channelContent = _.get(channels, SCP1_CH_ENUM[0]);
    if (channelContent != undefined) {
      channelArray.push([SCP1_CH_ENUM[0], channelContent]);
    } else {
      channelArray.push([undefined, undefined]);
    }
  } catch (error) {
    console.error("ERROR IN pH or ORP channel array");
  }
  try {
    //tAmb
    channelContent = _.get(channels, SCP1_CH_ENUM[1]);
    if (channelContent != undefined) {
      channelArray.push([SCP1_CH_ENUM[1], _.get(channels, SCP1_CH_ENUM[1])]);
    } else {
      channelArray.push([undefined, undefined]);
    }
  } catch (error) {
    console.error("ERROR IN scp1_tAmb channel array");
  }
  try {
    //tTC
    channelContent = _.get(channels, SCP1_CH_ENUM[2]);
    if (channelContent != undefined) {
      channelArray.push([SCP1_CH_ENUM[2], _.get(channels, SCP1_CH_ENUM[2])]);
    } else {
      channelArray.push([undefined, undefined]);
    }
  } catch (error) {
    console.error("ERROR IN scp1_tTC channel array");
  }

  return channelArray;
};

export const SCP1_ENABLED_ARRAY = (tool, enabledChannels) => {
  let enabledArray = [];
  if (enabledChannels == null) {
    enabledArray = [
      _.has(tool.settings.channels, "scp1_chem1") &&
        tool.settings.channels.scp1_chem1.enabled,
      _.has(tool.settings.channels, "scp1_tAmb") &&
        tool.settings.channels.scp1_tAmb.enabled,
      _.has(tool.settings.channels, "scp1_tTC") &&
        tool.settings.channels.scp1_tTC.enabled,
      false,
    ];
  } else {
    enabledArray.push(
      _.find(enabledChannels, function (o) {
        return o == "scp1_chem1";
      }) != undefined
    );
    enabledArray.push(
      _.find(enabledChannels, function (o) {
        return o == "scp1_tAmb";
      }) != undefined
    );
    enabledArray.push(
      _.find(enabledChannels, function (o) {
        return o == "scp1_tTC";
      }) != undefined
    );
    enabledArray.push(false);
  }
  return enabledArray;
};

export const SCP1_CONVERSION = (tool) => {
  let convertedSensor = {};

  try {
    //Convert pH or ORP
    if (tool.settings.channels.scp1_chem1.sensorType == "pH") {
      let phUnit = tool.settings.channels.scp1_chem1.unit;
      convertedSensor.scp1_chem1 = tool.sensor.scp1_chem1;
    } else {
      //ORP
      let orpUnit = tool.settings.channels.scp1_chem1.unit;
      if (tool.sensor.scp1_chem1 == null) {
        convertedSensor.scp1_chem1 = null;
      } else {
        if (orpUnit == SCP1_CHANNELS.scp1_chem1.unit.default) {
          //Default
          convertedSensor.scp1_chem1 = tool.sensor.scp1_chem1;
        } else {
          //Conversion needed
          if (orpUnit == SCP1_CHANNELS.scp1_chem1.unit.enum[1]) {
            //V
            convertedSensor.scp1_chem1 = tool.sensor.scp1_chem1 / 1000;
          }
        }
      }
    }
  } catch (error) {
    console.error("ERROR IN pH or ORP CONVERSION");
  }

  try {
    //Convert Amb Temp
    let tAmbUnit = tool.settings.channels.scp1_tAmb.unit;
    if (tool.sensor.scp1_tAmb == null) {
      convertedSensor.scp1_tAmb = null;
    } else {
      if (tAmbUnit == SCP1_CHANNELS.scp1_tAmb.unit.default) {
        //Default
        convertedSensor.scp1_tAmb = tool.sensor.scp1_tAmb;
      } else {
        //Conversion needed
        if (tAmbUnit == SCP1_CHANNELS.scp1_tAmb.unit.enum[1]) {
          //F
          convertedSensor.scp1_tAmb = (tool.sensor.scp1_tAmb * 9) / 5 + 32;
        } else if (tAmbUnit == SCP1_CHANNELS.scp1_tAmb.unit.enum[2]) {
          //K
          convertedSensor.scp1_tAmb = tool.sensor.scp1_tAmb + 273.15;
        }
      }
    }
  } catch (error) {
    console.error("ERROR IN scp1_tAmb CONVERSION");
  }

  try {
    //Convert Thermocouple
    let tTCUnit = tool.settings.channels.scp1_tTC.unit;
    if (tool.sensor.scp1_tTC == null) {
      convertedSensor.scp1_tTC = null;
    } else {
      if (tTCUnit == SCP1_CHANNELS.scp1_tTC.unit.default) {
        //Default
        convertedSensor.scp1_tTC = tool.sensor.scp1_tTC;
      } else {
        //Conversion needed
        if (tTCUnit == SCP1_CHANNELS.scp1_tTC.unit.enum[1]) {
          //F
          convertedSensor.scp1_tTC = (tool.sensor.scp1_tTC * 9) / 5 + 32;
        } else if (tTCUnit == SCP1_CHANNELS.scp1_tTC.unit.enum[2]) {
          //K
          convertedSensor.scp1_tTC = tool.sensor.scp1_tTC + 273.15;
        }
      }
    }
  } catch (error) {
    console.error("ERROR IN scp1_tTC CONVERSION");
  }

  return convertedSensor;
};

export const SCP1_GRAPH_CONVERSION = (tool, data, attributeArray) => {
  let tempData = _.cloneDeep(data);
  let orpIdx = _.findIndex(attributeArray, function (o) {
    return o == SCP1_CH_ENUM[0];
  });
  let tAmbIdx = _.findIndex(attributeArray, function (o) {
    return o == SCP1_CH_ENUM[1];
  });
  let tTCIdx = _.findIndex(attributeArray, function (o) {
    return o == SCP1_CH_ENUM[2];
  });

  tempData.forEach((dataPoint) => {
    try {
      if (tool.settings.channels.scp1_chem1.sensorType == "ORP") {
        let orpUnit = tool.settings.channels.scp1_chem1.unit;
        if (dataPoint[orpIdx] != null) {
          if (orpUnit != SCP1_CHANNELS.scp1_chem1.unit.default) {
            //Default
            if (orpUnit == SCP1_CHANNELS.scp1_chem1.unit.enum[1]) {
              //V
              dataPoint[orpIdx] = dataPoint[orpIdx] / 1000;
            }
          }
        }
      }
    } catch (error) {
      console.error("ERROR IN ORP graph CONVERSION");
    }
    try {
      let tAmbUnit = tool.settings.channels.scp1_tAmb.unit;
      if (dataPoint[tAmbIdx] != null) {
        if (tAmbUnit != SCP1_CHANNELS.scp1_tAmb.unit.default) {
          //Default
          if (tAmbUnit == SCP1_CHANNELS.scp1_tAmb.unit.enum[1]) {
            //F
            dataPoint[tAmbIdx] = (dataPoint[tAmbIdx] * 9) / 5 + 32;
          } else if (tAmbUnit == SCP1_CHANNELS.scp1_tAmb.unit.enum[2]) {
            //K
            dataPoint[tAmbIdx] = dataPoint[tAmbIdx] + 273.15;
          }
        }
      }
    } catch (error) {
      console.error("ERROR IN scp1_tAmb graph CONVERSION");
    }
    try {
      let tTCUnit = tool.settings.channels.scp1_tTC.unit;
      if (dataPoint[tTCIdx] != null) {
        if (tTCUnit != SCP1_CHANNELS.scp1_tTC.unit.default) {
          //Default
          if (tTCUnit == SCP1_CHANNELS.scp1_tTC.unit.enum[1]) {
            //F
            dataPoint[tTCIdx] = (dataPoint[tTCIdx] * 9) / 5 + 32;
          } else if (tTCUnit == SCP1_CHANNELS.scp1_tTC.unit.enum[2]) {
            //K
            dataPoint[tTCIdx] = dataPoint[tTCIdx] + 273.15;
          }
        }
      }
    } catch (error) {
      console.error("ERROR IN scp1_tTC graph CONVERSION");
    }
  });
  return tempData;
};

const SCP1_CHANNELS = {
  scp1_chem1: {
    name: { type: "S", default: "pH" },
    sensorType: { type: "E", default: "pH", enum: ["pH", "ORP"] },
    unit: { type: "E", default: "pH", enum: ["pH", "mV", "V"] },
    enabled: { type: "B", default: true },
  },
  scp1_tAmb: {
    name: { type: "S", default: "Ambient Temp" },
    unit: { type: "E", default: "°C", enum: ["°C", "°F", "°K"] },
    enabled: { type: "B", default: true },
  },
  scp1_tTC: {
    name: { type: "S", default: "Thermocouple Probe" },
    unit: { type: "E", default: "°C", enum: ["°C", "°F", "°K"] },
    sensorType: { type: "E", default: "K", enum: thermoProbeType },
    enabled: { type: "B", default: true },
  },
};

SCP1.ToolDashboardContainer = ({ navigate, currentTool, selected }) => {
  let roundedPh;
  let roundedOrp;
  let roundedTAmb;
  let roundedTTC;
  try {
    if (currentTool.convertedSensor.scp1_chem1 != undefined) {
      if (currentTool.settings.channels.scp1_chem1.sensorType == "pH") {
        roundedPh =
          currentTool.convertedSensor.scp1_chem1 != "NC" &&
          currentTool.settings.channels.scp1_chem1.sensorType == "pH"
            ? Number(currentTool.convertedSensor.scp1_chem1).toFixed(2)
            : "--";
        if (isNaN(roundedPh)) roundedPh = "--";
      } else {
        roundedOrp =
          currentTool.convertedSensor.scp1_chem1 != "NC" &&
          currentTool.settings.channels.scp1_chem1.sensorType == "ORP"
            ? Number(currentTool.convertedSensor.scp1_chem1).toFixed(1)
            : "--";
        if (isNaN(roundedOrp)) roundedOrp = "--";
      }
    }
  } catch (error) {
    console.error("ERROR Getting roundedPh or roundedOrp:", error);
  }
  try {
    if (currentTool.convertedSensor.scp1_tAmb != undefined) {
      roundedTAmb =
        currentTool.convertedSensor.scp1_tAmb != "NC"
          ? Number(currentTool.convertedSensor.scp1_tAmb).toFixed(1)
          : "--";
      if (isNaN(roundedTAmb)) roundedTAmb = "--";
    }
  } catch (error) {
    console.error("ERROR Getting roundedTAmb");
  }
  try {
    if (currentTool.convertedSensor.scp1_tTC != undefined) {
      roundedTTC =
        currentTool.convertedSensor.scp1_tTC != "NC"
          ? Number(currentTool.convertedSensor.scp1_tTC).toFixed(1)
          : "--";
      if (isNaN(roundedTTC)) roundedTTC = "--";
    }
  } catch (error) {
    console.error("ERROR Getting roundedTTC");
  }
  let onPress;
  if (_.has(currentTool, "mac")) {
    onPress = () => navigate(`/site/${currentTool.mac}`);
  } else {
    onPress = () => navigate(`/site/${currentTool.share_id}`);
  }
  let usbPowered =
    _.has(currentTool, "toolSystem") && !_.isEmpty(currentTool.toolSystem)
      ? currentTool.toolSystem.sysPowerState == "USB"
      : undefined;
  let batteryLvl =
    _.has(currentTool, "toolSystem") &&
    !_.isEmpty(currentTool.toolSystem) &&
    currentTool.toolSystem.sysBatteryLvl
      ? currentTool.toolSystem.sysBatteryLvl
      : undefined;
  let cloudConnected = false;
  if (_.has(currentTool, "nextUpdateTS"))
    cloudConnected = HelperService.isCloudConnected(currentTool.nextUpdateTS);
  return (
    <Dashboard.Overview
      title={currentTool.settings.toolName}
      description={"ChemSense"}
      shared={!_.has(currentTool, "mac")}
      symbol={toolIcon}
      usbPowered={usbPowered}
      batteryLvl={batteryLvl}
      cloudConnected={cloudConnected}
      onPress={onPress}
      alerts={currentTool.alerts}
      selected={selected}
    >
      {_.has(currentTool, "sensor") && !_.isEmpty(currentTool.sensor) ? (
        <ViewRow>
          {roundedPh != undefined &&
          currentTool.settings.channels.scp1_chem1.enabled &&
          currentTool.settings.channels.scp1_chem1.sensorType == "pH" ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedPh}
              units={
                roundedPh == "--"
                  ? ""
                  : currentTool.settings.channels.scp1_chem1.unit
              }
              label={currentTool.settings.channels.scp1_chem1.name}
            />
          ) : (
            <></>
          )}
          {roundedOrp != undefined &&
          currentTool.settings.channels.scp1_chem1.enabled &&
          currentTool.settings.channels.scp1_chem1.sensorType == "ORP" ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedOrp}
              units={
                roundedOrp == "--"
                  ? ""
                  : currentTool.settings.channels.scp1_chem1.unit
              }
              label={currentTool.settings.channels.scp1_chem1.name}
            />
          ) : (
            <></>
          )}
          {roundedTAmb != undefined &&
          currentTool.settings.channels.scp1_tAmb.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedTAmb}
              units={
                roundedTAmb == "--"
                  ? ""
                  : currentTool.settings.channels.scp1_tAmb.unit
              }
              label={currentTool.settings.channels.scp1_tAmb.name}
            />
          ) : (
            <></>
          )}
          {roundedTTC != undefined &&
          currentTool.settings.channels.scp1_tTC.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value={roundedTTC}
              units={
                roundedTTC == "--"
                  ? ""
                  : currentTool.settings.channels.scp1_tTC.unit
              }
              label={currentTool.settings.channels.scp1_tTC.name}
            />
          ) : (
            <></>
          )}
        </ViewRow>
      ) : (
        <ViewRow>
          {roundedPh != undefined &&
          currentTool.settings.channels.scp1_chem1.enabled &&
          currentTool.settings.channels.scp1_chem1.sensorType == "pH" ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.scp1_chem1.name}
            />
          ) : (
            <></>
          )}
          {roundedOrp != undefined &&
          currentTool.settings.channels.scp1_chem1.enabled &&
          currentTool.settings.channels.scp1_chem1.sensorType == "ORP" ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.scp1_chem1.name}
            />
          ) : (
            <></>
          )}
          {roundedTAmb != undefined &&
          currentTool.settings.channels.scp1_tAmb.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.scp1_tAmb.name}
            />
          ) : (
            <></>
          )}
          {roundedTTC != undefined &&
          currentTool.settings.channels.scp1_tTC.enabled ? (
            <Dashboard.Value
              style={styles.dashboardValue}
              value="--"
              units=""
              label={currentTool.settings.channels.scp1_tTC.name}
            />
          ) : (
            <></>
          )}
        </ViewRow>
      )}
    </Dashboard.Overview>
  );
};

SCP1.OverviewContainer = ({ currentTool, stats, enabled, setEnabled }) => {
  let fontSize = "xxlarge";
  let roundedPh;
  let roundedOrp;
  let roundedTAmb;
  let roundedTTC;
  try {
    if (currentTool.convertedSensor.scp1_chem1 != undefined) {
      if (currentTool.settings.channels.scp1_chem1.sensorType == "pH") {
        roundedPh =
          currentTool.convertedSensor.scp1_chem1 != "NC" &&
          currentTool.settings.channels.scp1_chem1.sensorType == "pH"
            ? Number(currentTool.convertedSensor.scp1_chem1).toFixed(2)
            : "--";
        if (isNaN(roundedPh)) roundedPh = "--";
      } else {
        //ORP
        roundedOrp =
          currentTool.convertedSensor.scp1_chem1 != "NC" &&
          currentTool.settings.channels.scp1_chem1.sensorType == "ORP"
            ? Number(currentTool.convertedSensor.scp1_chem1).toFixed(1)
            : "--";
        if (isNaN(roundedOrp)) roundedOrp = "--";
      }
    } else {
      if (currentTool.settings.channels.scp1_chem1.sensorType == "pH") {
        roundedPh = "X";
      } else {
        roundedOrp = "X";
      }
    }
  } catch (error) {
    console.error("ERROR Getting roundedPh or roundedOrp");
    roundedPh = "X";
    roundedOrp = "X";
  }
  try {
    if (currentTool.convertedSensor.scp1_tAmb != undefined) {
      roundedTAmb =
        currentTool.convertedSensor.scp1_tAmb != "NC"
          ? Number(currentTool.convertedSensor.scp1_tAmb).toFixed(1)
          : "--";
      if (isNaN(roundedTAmb)) roundedTAmb = "--";
    } else {
      roundedTAmb = "X";
    }
  } catch (error) {
    console.error("ERROR Getting roundedTAmb");
    roundedTAmb = "X";
  }
  try {
    if (currentTool.convertedSensor.scp1_tTC != undefined) {
      roundedTTC =
        currentTool.convertedSensor.scp1_tTC != "NC"
          ? Number(currentTool.convertedSensor.scp1_tTC).toFixed(1)
          : "--";
      if (isNaN(roundedTTC)) roundedTTC = "--";
    } else {
      roundedTTC = "X";
    }
  } catch (error) {
    console.error("ERROR Getting roundedTTC");
    roundedTTC = "X";
  }
  const changeFontSize = () => {
    //xlarge 7-9 large 10, medium 11, 12-13 small, 14-15 hint
    console.log("ROUNDED PH:", roundedPh, "ROUNDED ORP:", roundedOrp);
    if (
      roundedPh == undefined ||
      roundedOrp == undefined ||
      roundedTAmb == undefined ||
      roundedTTC == undefined
    ) {
      //Don't change font
    } else {
      if (
        roundedPh.toString().length >= 14 ||
        roundedOrp.toString().length >= 14 ||
        roundedTAmb.toString().length >= 14 ||
        roundedTTC.toString().length >= 14
      ) {
        fontSize = "hint";
      } else if (
        roundedPh.toString().length > 11 ||
        roundedOrp.toString().length > 11 ||
        roundedTAmb.toString().length > 11 ||
        roundedTTC.toString().length > 11
      ) {
        fontSize = "small";
      } else if (
        roundedPh.toString().length > 10 ||
        roundedOrp.toString().length > 10 ||
        roundedTAmb.toString().length > 10 ||
        roundedTTC.toString().length > 10
      ) {
        fontSize = "medium";
      } else if (
        roundedPh.toString().length > 9 ||
        roundedOrp.toString().length > 9 ||
        roundedTAmb.toString().length > 9 ||
        roundedTTC.toString().length > 9
      ) {
        fontSize = "large";
      } else if (
        roundedPh.toString().length > 6 ||
        roundedOrp.toString().length > 6 ||
        roundedTAmb.toString().length > 6 ||
        roundedTTC.toString().length > 6
      ) {
        fontSize = "xlarge";
      }
    }
  };
  return (
    <View>
      {_.has(currentTool, "sensor") && !_.isEmpty(currentTool.sensor) ? (
        <View style={styles.dashboardView}>
          {changeFontSize()}
          {roundedPh != "X" &&
          currentTool.settings.channels.scp1_chem1.enabled &&
          currentTool.settings.channels.scp1_chem1.sensorType == "pH" ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              label={currentTool.settings.channels.scp1_chem1.name}
              value={roundedPh}
              units={
                roundedPh == "--"
                  ? ""
                  : currentTool.settings.channels.scp1_chem1.unit
              }
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[0][0] != null ? stats[0][0].toFixed(1) : "--"}
              low={stats[0][1] != null ? stats[0][1].toFixed(1) : "--"}
              avg={stats[0][2] != null ? stats[0][2].toFixed(1) : "--"}
              icon={phIcon}
              color={enabled[0] ? channelColors[0] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={0}
            />
          ) : (
            <></>
          )}
          {roundedOrp != "X" &&
          currentTool.settings.channels.scp1_chem1.enabled &&
          currentTool.settings.channels.scp1_chem1.sensorType == "ORP" ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              label={currentTool.settings.channels.scp1_chem1.name}
              value={roundedOrp}
              units={
                roundedOrp == "--"
                  ? ""
                  : currentTool.settings.channels.scp1_chem1.unit
              }
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[0][0] != null ? stats[0][0].toFixed(1) : "--"}
              low={stats[0][1] != null ? stats[0][1].toFixed(1) : "--"}
              avg={stats[0][2] != null ? stats[0][2].toFixed(1) : "--"}
              icon={orpIcon}
              color={enabled[0] ? channelColors[0] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={0}
            />
          ) : (
            <></>
          )}
          {roundedTAmb != "X" &&
          currentTool.settings.channels.scp1_tAmb.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              label={currentTool.settings.channels.scp1_tAmb.name}
              value={roundedTAmb}
              units={
                roundedTAmb == "--"
                  ? ""
                  : currentTool.settings.channels.scp1_tAmb.unit
              }
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[1][0] != null ? stats[1][0].toFixed(1) : "--"}
              low={stats[1][1] != null ? stats[1][1].toFixed(1) : "--"}
              avg={stats[1][2] != null ? stats[1][2].toFixed(1) : "--"}
              icon={ambIcon}
              color={enabled[1] ? channelColors[1] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={1}
            />
          ) : (
            <></>
          )}
          {roundedTTC != "X" &&
          currentTool.settings.channels.scp1_tTC.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              label={currentTool.settings.channels.scp1_tTC.name}
              sensorType={currentTool.settings.channels.scp1_tTC.sensorType}
              value={roundedTTC}
              units={
                roundedTTC == "--"
                  ? ""
                  : currentTool.settings.channels.scp1_tTC.unit
              }
              live={sensorLive.isLive(currentTool.sensor.updatedAt)}
              high={stats[2][0] != null ? stats[2][0].toFixed(1) : "--"}
              low={stats[2][1] != null ? stats[2][1].toFixed(1) : "--"}
              avg={stats[2][2] != null ? stats[2][2].toFixed(1) : "--"}
              icon={thermIcon}
              color={enabled[2] ? channelColors[2] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={2}
            />
          ) : (
            <></>
          )}
        </View>
      ) : (
        <View style={styles.dashboardView}>
          {roundedPh != "X" &&
          currentTool.settings.channels.scp1_chem1.enabled &&
          currentTool.settings.channels.scp1_chem1.sensorType == "pH" ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              label={currentTool.settings.channels.scp1_chem1.name}
              value="--"
              units=""
              live={false}
              low="--"
              high="--"
              avg="--"
              icon={phIcon}
              color={enabled[0] ? channelColors[0] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={0}
            />
          ) : (
            <></>
          )}
          {roundedOrp != "X" &&
          currentTool.settings.channels.scp1_chem1.enabled &&
          currentTool.settings.channels.scp1_chem1.sensorType == "ORP" ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              label={currentTool.settings.channels.scp1_chem1.name}
              value="--"
              units=""
              live={false}
              low="--"
              high="--"
              avg="--"
              icon={orpIcon}
              color={enabled[0] ? channelColors[0] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={0}
            />
          ) : (
            <></>
          )}
          {roundedTAmb != "X" &&
          currentTool.settings.channels.scp1_tAmb.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              label={currentTool.settings.channels.scp1_tAmb.name}
              value="--"
              units=""
              live={false}
              low="--"
              high="--"
              avg="--"
              icon={ambIcon}
              color={enabled[1] ? channelColors[1] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={1}
            />
          ) : (
            <></>
          )}
          {roundedTTC != "X" &&
          currentTool.settings.channels.scp1_tTC.enabled ? (
            <Dashboard.OverviewValue
              style={styles.overviewValue}
              size={fontSize}
              label={currentTool.settings.channels.scp1_tTC.name}
              sensorType={currentTool.settings.channels.scp1_tTC.sensorType}
              value="--"
              units=""
              live={false}
              low="--"
              high="--"
              avg="--"
              icon={thermIcon}
              color={enabled[2] ? channelColors[2] : Colors.vlightGrey}
              enabled={enabled}
              setEnabled={setEnabled}
              index={2}
            />
          ) : (
            <></>
          )}
        </View>
      )}
    </View>
  );
};

export const SCP1ChannelContainer = ({ currentTool, channelKey }) => {
  const [chError, setChError] = useState(true);
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  // try {
  // const dispatch = useDispatch()
  const units = {
    scp1_chem1: SCP1_CHANNELS.scp1_chem1.unit.enum,
    scp1_tAmb: SCP1_CHANNELS.scp1_tAmb.unit.enum,
    scp1_tTC: SCP1_CHANNELS.scp1_tTC.unit.enum,
  };
  const [chName, setChName] = useState(
    _.get(currentTool.settings.channels, channelKey).name
  );
  const [chEn, setChEn] = useState(
    _.get(currentTool.settings.channels, channelKey).enabled
  );
  const [chEnTool, setChEnTool] = useState(
    _.get(currentTool.toolSettings.channels, channelKey).enabled
  );
  const [chEnTime, setChEnTime] = useState(true);
  const [chUnit, setChUnit] = useState(
    _.get(currentTool.settings.channels, channelKey).unit
  );
  const [chSensorType, setChSensorType] = useState(
    _.get(currentTool.settings.channels, channelKey).sensorType
  );
  const [chSensorTypeTool, setChSensorTypeTool] = useState(
    _.get(currentTool.toolSettings.channels, channelKey).sensorType
  );
  const [chSensorTypeTime, setChSensorTypeTime] = useState(true);
  let graphData = allSites.graphData;
  let index = _.indexOf(SCP1_CH_ENUM, channelKey);
  let chemIcon;
  if (channelKey == "scp1_chem1") {
    if (currentTool.settings.channels.scp1_chem1.sensorType == "pH") {
      chemIcon = phIcon;
    } else {
      chemIcon = orpIcon;
    }
  }
  let icon = [chemIcon, ambIcon, thermIcon][index];
  let tempGraphProps = currentTool.settings.graphPropsDashboard;
  console.log("TEMP GRAPH PROPS:", tempGraphProps);
  let tempSettings = currentTool.settings;

  useEffect(() => {
    console.log("Channel Key or Tool Changed!");
    setChName(_.get(currentTool.settings.channels, channelKey).name);
    setChEn(_.get(currentTool.settings.channels, channelKey).enabled);
    setChEnTime(true);
    setChUnit(_.get(currentTool.settings.channels, channelKey).unit);
    setChEnTool(_.get(currentTool.toolSettings.channels, channelKey).enabled);
    setChSensorType(
      _.get(currentTool.settings.channels, channelKey).sensorType
    );
    setChSensorTypeTool(
      _.get(currentTool.toolSettings.channels, channelKey).sensorType
    );
  }, [currentTool, channelKey]);

  function updateSettings(object, pullAfter) {
    updateToolSettings(currentTool, object).then(async () => {
      if (pullAfter) {
        await HelperService.delayMs(1000);
        getSettings(currentTool);
      }
    });
  }
  async function getSettings(object) {
    console.log("updated Settings SDP1:", object);
    let settings = await getToolSettings(currentTool, object).then(
      (settings) => settings
    );
    let tempAllSites = _.cloneDeepWith(allSites);
    let mac = currentTool?.mac ? currentTool.mac : currentTool.share_id;
    tempAllSites[mac].settings = settings.settings;
    tempAllSites[mac].toolSettings = settings.toolSettings;
    tempAllSites[mac].toolSystem = settings.toolSystem;
    setAllSites(tempAllSites);
  }

  const timer0 = useRef(null);
  const timer1 = useRef(null);
  async function updateChEnTime() {
    clearTimeout(timer0.current);
    timer0.current = null;
    setChEnTime(false);
    timer0.current = setTimeout(async () => {
      getSettings(currentTool);
      await HelperService.delayMs(1000);
      setChEnTime(true);
    }, toolSyncTime - 1000);
  }
  async function updateChSensorTypeTime() {
    clearTimeout(timer1.current);
    timer1.current = null;
    setChSensorTypeTime(false);
    timer1.current = setTimeout(async () => {
      getSettings(currentTool);
      await HelperService.delayMs(1000);
      setChSensorTypeTime(true);
    }, toolSyncTime - 1000);
  }

  return (
    <View>
      <Row.Toggle //Enable/Disable
        title="Status"
        icon={powerIcon}
        value={chEn}
        toolValue={chEnTool}
        syncTime={chEnTime}
        tool={currentTool}
        getSettings={getSettings}
        onValueChange={(value) => {
          setChEn(value);
          tempSettings.channels[channelKey].enabled = value;
          if (!_.isEmpty(tempGraphProps))
            tempGraphProps.enY = SCP1_DEFAULT_Y_AXIS(tempSettings);
          updateSettings(
            {
              channels: { [channelKey]: { enabled: value } },
              graphPropsDashboard: tempGraphProps,
            },
            false
          );
          updateChEnTime();
          //UPDATE GRAPH DATA
          let tempGraphData = _.cloneDeep(graphData);
          tempGraphData.delete(currentTool.data_id);
          // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
          //TODO reload data
        }}
      />
      <Row.Setting //Name
        title="Channel Name"
        icon={icon}
        color={channelColors[index]}
        setting={chName}
        changeSetting={setChName}
        setSetting={() =>
          updateSettings({ channels: { [channelKey]: { name: chName } } }, true)
        }
      />
      <Row.Picker //Unit
        title="Unit"
        icon={unitIcon}
        values={_.get(units, channelKey)}
        value={chUnit}
        setValue={setChUnit}
        onPress={(value) => {
          setChUnit(value);
          tempSettings.channels[channelKey].unit = value;
          if (!_.isEmpty(tempGraphProps))
            tempGraphProps.enY = SCP1_DEFAULT_Y_AXIS(tempSettings);
          updateSettings(
            {
              channels: { [channelKey]: { unit: value } },
              graphPropsDashboard: tempGraphProps,
            },
            true
          );
          //UPDATE GRAPH DATA
          let tempGraphData = graphData;
          tempGraphData.delete(currentTool.data_id);
          // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
        }}
      />

      {channelKey == SCP1_CH_ENUM[0] ? ( //pH or ORP
        <View>
          <Row.TwoToggle
            title="Operation Mode"
            value={chSensorType == "pH"}
            toolValue={chSensorTypeTool == "pH"}
            syncTime={chSensorTypeTime}
            tool={currentTool}
            getSettings={getSettings}
            onValueChange={(value) => {
              setChSensorType(value);
              let type = value ? "pH" : "ORP";
              tempSettings.channels[channelKey].sensorType = type;
              if (!_.isEmpty(tempGraphProps))
                tempGraphProps.enY = SCP1_DEFAULT_Y_AXIS(tempSettings);
              updateSettings(
                { channels: { [channelKey]: { sensorType: type } } },
                false
              );
              updateChSensorTypeTime();
              // let tempGraphProps = tool.settings.graphPropsDashboard
              // let tempSettings = tool.settings
              // tempSettings.channels.scp1_chem1.sensorType = type
              // tempGraphProps.enY = SCP1_DEFAULT_Y_AXIS(tempSettings)
              // updateSettings({ controls: { sensorType: type },graphPropsDashboard:tempGraphProps })
              // let tempGraphData = _.cloneDeep(graphData)
              // tempGraphData.delete(tool.data_id)
              // dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
            }}
            option1={"ORP"}
            option2={"pH"}
          />
          {/* <Row.SettingLink  
            title="Calibration"
            symbol={calibrationIcon}
            onPress = {() => NavigationService.navigate('Modal',
            {screen: 'CalibrationSCP1',params: {mac:currentTool.mac,share_id:currentTool.share_id}})}/> */}
        </View>
      ) : (
        <></>
      )}
      {channelKey == SCP1_CH_ENUM[2] ? ( //thermocouple
        <Row.Picker //SensorType
          title="Sensor Type"
          icon={sensorIcon}
          values={thermoProbeType}
          value={chSensorType}
          setValue={setChSensorType}
          toolValue={chSensorTypeTool}
          syncTime={chSensorTypeTime}
          tool={currentTool}
          getSettings={getSettings}
          onPress={(value) => {
            setChSensorType(value);
            tempSettings.channels[channelKey].sensorType = value;
            if (!_.isEmpty(tempGraphProps))
              tempGraphProps.enY = SCP1_DEFAULT_Y_AXIS(tempSettings);
            updateSettings(
              { channels: { [channelKey]: { sensorType: value } } },
              false
            );
            updateChSensorTypeTime();
          }}
        />
      ) : (
        <></>
      )}
    </View>
  );
  // } catch (error) {
  //   return(
  //     <View>
  //       <Alert visible={chError} setVisible={setChError} title="Error: Channel Setting Mismatch"
  //       text={"Unable to display Tool's channel settings. Please update your Tool's firmware to resolve this issue."} oneButton={true}
  //       onPress={async ()=>{
  //         setChError(false)
  //       }}/>
  //     </View>
  //     )
  // }
};

// SCP1.ToolChemToggleContainer = ({ tool }) => {
//     const dispatch = useDispatch()
//     const graphData = useSelector((state) => getAllGraphData(state))

//     function updateSettings(object) {
//         dispatch(ToolActions.updateUserTool(tool, object))
//     }

//     return(
//         <Row.TwoToggle
//             title="Operation Mode"
//             value={tool.settings.channels.scp1_chem1.sensorType == 'pH'}
//             onValueChange={(value) => {
//                   let type = value?'pH':'ORP'
//                   let tempGraphProps = tool.settings.graphPropsDashboard
//                   let tempSettings = tool.settings
//                   tempSettings.channels.scp1_chem1.sensorType = type
//                   tempGraphProps.enY = SCP1_DEFAULT_Y_AXIS(tempSettings)
//                   updateSettings({ controls: { sensorType: type },graphPropsDashboard:tempGraphProps })
//                   let tempGraphData = _.cloneDeep(graphData)
//                   tempGraphData.delete(tool.data_id)
//                   dispatch(ToolActions.addToolGraphDataToStore(tempGraphData,null,null))//Clear data
//                 }}
//             option1 = {"ORP"}
//             option2 = {"pH"}
//         />
//     )
// }
export const SCP1_GRAPH_INFO = async (
  tool,
  tsIdx,
  attributes,
  file,
  fileRaw,
  xdata,
  channels,
  data,
  tempUnits,
  dataRawTemp
) => {
  const chem1Idx = _.indexOf(attributes, "scp1_chem1");
  const tAmbIdx = _.indexOf(attributes, "scp1_tAmb");
  const tTCIdx = _.indexOf(attributes, "scp1_tTC");
  console.log(
    "SCP1-- scp1_chem1:",
    chem1Idx,
    "tAmbIdx:",
    tAmbIdx,
    "tTCIdx:",
    tTCIdx
  );
  await file.forEach((item, index) => {
    xdata[index] = item[tsIdx];
    if (chem1Idx != -1) {
      channels[0] = tool.settings.channels.scp1_chem1.name;
      data[0][index] = { x: xdata[index], y: item[chem1Idx] };
      tempUnits[0] = tool.settings.channels.scp1_chem1.unit;
    }
    if (tAmbIdx != -1) {
      channels[1] = tool.settings.channels.scp1_tAmb.name;
      data[1][index] = { x: xdata[index], y: item[tAmbIdx] };
      tempUnits[1] = tool.settings.channels.scp1_tAmb.unit;
    }
    if (tTCIdx != -1) {
      channels[2] = tool.settings.channels.scp1_tTC.name;
      data[2][index] = { x: xdata[index], y: item[tTCIdx] };
      tempUnits[2] = tool.settings.channels.scp1_tTC.unit;
    }
  });
  await fileRaw.forEach((item, index) => {
    if (chem1Idx != -1)
      dataRawTemp[0][index] = { x: xdata[index], y: item[chem1Idx] };
    if (tAmbIdx != -1)
      dataRawTemp[1][index] = { x: xdata[index], y: item[tAmbIdx] };
    if (tTCIdx != -1)
      dataRawTemp[2][index] = { x: xdata[index], y: item[tTCIdx] };
  });

  return [channels, data, tempUnits, dataRawTemp];
};

export default SCP1;
